import { useIntl } from "react-intl";
import { Col, Row } from "reactstrap";
import Layout from "../../components/Layout/Layout";
import PageTitle from "../../components/Layout/PageTitle";
import InputComponent from "../../components/InputComponent";
import ButtonComponent from "../../components/ButtonComponent";
import { useState } from "react";
import { CreateSupplierDTO } from "../../models/Supplier/CreateSupplierDTO";
import { SupplierService } from "../../services/SupplierService";
import { useNavigate } from "react-router-dom";
import Routes from "../../helpers/Routes";
import Toast from "../../helpers/Toast";

export default function SupplierCreate() {
  const intl = useIntl();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [supplier, setSupplier] = useState<CreateSupplierDTO>({
    name: null,
    emailAddress: null,
    address: null,
    type: null,
    notes: null,
    phoneNumber: null
  });

  const handleInputChange = (name: string, value: any) => {
    setSupplier({
      ...supplier,
      [name]: value
    });
  };

  const handleSubmit = async () => {
    setIsLoading(true);

    const supplierService = new SupplierService();
    const response = await supplierService.Create(supplier);

    if (response.success) {
      Toast.Show("success", intl.formatMessage({ id: "Screens.Suppliers.Create.Success" }));
      navigate(Routes.suppliers.list);
    } else {
      Toast.Show("error", response.message || intl.formatMessage({ id: "Screens.Suppliers.Create.Error" }));
    }

    setIsLoading(false);
  };

  // Wrapper function for ButtonComponent
  const handleSaveClick = () => {
    handleSubmit();
  };

  return (
    <Layout>
      <div className="pageContainer">
        <div className="pageHeader">
          <Row style={{ margin: "0px", padding: "0px" }}>
            <Col style={{ margin: "0px", padding: "0px" }}>
              <PageTitle
                title={`${intl.formatMessage({
                  id: "Screens.Suppliers.Create.Title",
                })}:`}
                allowGoBack={true}
              />
            </Col>
          </Row>
        </div>

        <div className="pageBody">
          <label style={{ margin: "0px", padding: "13px" }}>
            <b>{intl.formatMessage({ id: "Screens.Suppliers.Create.FormTitle" })}</b>
          </label>
          <Row
            style={{
              margin: "0px",
              padding: "0px",
              alignItems: "flex-end",
              alignContent: "flex-end",
            }}
          >
                <Row>
                  <InputComponent
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    type="text"
                    label={intl.formatMessage({ id: "Screens.Suppliers.Form.Name" })}
                    value={supplier.name || ""}
                    onChange={(value) => handleInputChange("name", value)}
                    readOnly={false}
                  />
                  <InputComponent
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    type="text"
                    label={intl.formatMessage({ id: "Screens.Suppliers.Form.Email" })}
                    value={supplier.emailAddress || ""}
                    onChange={(value) => handleInputChange("emailAddress", value)}
                    readOnly={false}
                  />
                </Row>
                <Row>
                  <InputComponent
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    type="text"
                    label={intl.formatMessage({ id: "Screens.Suppliers.Form.Phone" })}
                    value={supplier.phoneNumber || ""}
                    onChange={(value) => handleInputChange("phoneNumber", value)}
                    readOnly={false}
                  />
                  <InputComponent
                    xl={6}
                    lg={6}
                    md={6}
                    sm={12}
                    xs={12}
                    type="text"
                    label={intl.formatMessage({ id: "Screens.Suppliers.Form.Type" })}
                    value={supplier.type || ""}
                    onChange={(value) => handleInputChange("type", value)}
                    readOnly={false}
                  />
                </Row>
                <Row>
                  <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    type="text"
                    label={intl.formatMessage({ id: "Screens.Suppliers.Form.Address" })}
                    value={supplier.address || ""}
                    onChange={(value) => handleInputChange("address", value)}
                    readOnly={false}
                  />
                </Row>
                <Row>
                  <InputComponent
                    xl={12}
                    lg={12}
                    md={12}
                    sm={12}
                    xs={12}
                    type="textArea"
                    rows={4}
                    label={intl.formatMessage({ id: "Screens.Suppliers.Form.Notes" })}
                    value={supplier.notes || ""}
                    onChange={(value) => handleInputChange("notes", value)}
                    readOnly={false}
                  />
                </Row>
                <Row style={{ marginTop: "20px" }}>
                  <Col xl={12} className="d-flex gap-2">
                    <ButtonComponent
                      text={isLoading 
                        ? intl.formatMessage({ id: "Common.Loading" }) 
                        : intl.formatMessage({ id: "Screens.Suppliers.Form.Submit" })}
                      onClick={handleSaveClick}
                      loading={isLoading}
                      disabled={isLoading}
                    />
                  </Col>
                </Row>
          </Row>
        </div>
      </div>
    </Layout>
  );
}
